/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const graph_increase = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 15h1m13.5 0h-1M2.662 6.04 12.66 1.5M10.68.757l1.98.743-.743 1.98M1.75 15v-3.267a.467.467 0 0 1 .467-.466h1.566a.466.466 0 0 1 .467.466V15m-2.5 0h2.5m0 0h2.5m0 0V8.933a.467.467 0 0 1 .467-.466h1.566a.467.467 0 0 1 .467.466V15m-2.5 0h2.5m0 0h2.424m0 0V7.067a.467.467 0 0 1 .466-.467h1.643a.467.467 0 0 1 .467.467V15m-2.576 0h2.576"
    />
  </svg>
)
export default graph_increase
